import { render, staticRenderFns } from "./RelatorioJustificativaNaoAtendimentoRoute.vue?vue&type=template&id=6073aa32"
import script from "./RelatorioJustificativaNaoAtendimentoRoute.vue?vue&type=script&lang=js"
export * from "./RelatorioJustificativaNaoAtendimentoRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports